import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, BookOpenIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { heroBullets, PACK_IMAGE, BRAND, CHECKOUT_URL, PRODUCT } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b border-line bg-canvasAlt" data-id="element-132" data-mp="4jvv38zjv4v7">
      <div className="mx-auto flex max-w-page flex-col items-center px-4 sm:px-6 lg:px-8 pt-4 pb-10 text-center" data-id="element-133" data-mp="12860zz2gicrl">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.28em] text-accent" data-id="element-134" data-mp="xaxj7zl80aqv">
          <BookOpenIcon size={14} className="text-gold" data-id="element-135" data-mp="3d2labedjz91r" />
          {BRAND}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 max-w-4xl font-display text-[1.6rem] leading-[1.15] sm:text-4xl lg:text-[2.6rem] font-bold uppercase text-ink" data-id="element-136" data-mp="3825wklpczzj9">
          ¿Leés la Biblia…{' '}
          <span className="text-accent" data-id="element-137" data-mp="39cfkx0rpn1u1">pero te cuesta entenderla?</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} src={PACK_IMAGE} alt={`${PRODUCT}: 6 tomos y 6 bonos digitales de estudio bíblico`} className="mt-2 max-h-[34vh] w-auto max-w-full object-contain sm:max-h-[38vh] lg:max-h-[40vh]" data-id="element-138" data-mp="3ebiripnc9g44" />

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.14
      }} className="mt-2 flex w-full max-w-xl flex-col items-center" data-id="element-139" data-mp="2vgu075sif47f">
          <p className="font-display text-lg md:text-2xl font-bold uppercase leading-tight text-accent" data-id="element-140" data-mp="s2b9g2qj4r79">
            {PRODUCT}
          </p>
          <p className="mt-1 max-w-2xl text-sm md:text-base font-semibold leading-snug text-ink" data-id="element-141" data-mp="na08cwk1yzd4">
            Aprendé a leer, comprender, reflexionar y aplicar las Escrituras en
            aproximadamente 15 minutos al día.
          </p>
          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3 max-w-md shadow-sm" data-id="element-142" data-mp="1b0nkju104b5h">
            Quiero comprender mejor la Biblia
          </CtaButton>
          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-ink-muted" data-id="element-143" data-mp="111y8wizp7mxo">
            <span className="flex items-center gap-1.5" data-id="element-144" data-mp="x0csinnygqiq">
              <ShieldCheckIcon size={14} className="text-success" data-id="element-145" data-mp="3lsp33cogahdw" />
              Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-146" data-mp="3hr3sxz3awh7e">
              <LockIcon size={14} className="text-ink-subtle" data-id="element-147" data-mp="3htq03xma4up3" />
              Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-148" data-mp="1x7hxtje7id3i">
              <ZapIcon size={14} className="text-gold" data-id="element-149" data-mp="21bpjf7pdbcxi" />
              Acceso digital inmediato
            </span>
          </div>
        </motion.div>

        <p className="mt-8 max-w-3xl text-base md:text-lg leading-relaxed text-ink-muted" data-id="element-150" data-mp="2b0pptc679alq">
          Querés acercarte a las Escrituras, pero entre pasajes difíciles,
          contextos que desconocés y no saber por dónde empezar, muchas veces
          terminás confundido o abandonando.{' '}
          <span className="font-semibold text-ink" data-id="element-151" data-mp="2p0h7bmvxd94h">
            No necesitás conocimientos teológicos: solo una ruta clara para
            empezar.
          </span>
        </p>

        <ul className="mx-auto mt-4 flex max-w-4xl flex-wrap justify-center gap-2" data-id="element-152" data-mp="2txhddxsrybvl">
          {heroBullets.map(bullet => <li key={bullet} className="flex items-center gap-2 rounded-full border border-line bg-surface px-4 py-2 text-sm text-ink" data-id="element-153" data-mp="zlaqw2ufk8nz">
              <CheckIcon size={14} className="flex-shrink-0 text-gold" strokeWidth={3} data-id="element-154" data-mp="4d75t1sa75zs" />
              <span data-id="element-155" data-mp="e8iofv6t8xct">{bullet}</span>
            </li>)}
        </ul>
      </div>
    </header>;
}